import axios from 'axios';
import router from '@/router';
import App from '@/main.js';
import store from '@/store';

axios.defaults.withCredentials = true;

const service = axios.create({
    baseURL: process.env.VUE_APP_SERVER || window.location.origin,
    timeout: 5000
});

service.interceptors.request.use(
	config => {
        const token = localStorage.getItem('user-token');

		if (token) {
			config.headers = Object.assign({}, config.headers, {
				'Authorization': token
			})
		}

		return config
	},
	error => Promise.reject(error)
)

service.interceptors.response.use(
    res => Promise.resolve(res),
    error => {
        console.log(error.response)
        if (error.response && error.response.status == 401 && !['/login'].includes(App.$route.path)) {
            store.commit('AUTH_ERROR');
            localStorage.removeItem('user-token')

            router.push('/login');
        }

        return Promise.reject(error);
    }
);

export default service;
